import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

function EsgAccessRoute({ children }) {
  const authUser = useSelector((state) => state.auth.user);

  if (authUser?.can_access_esg !== true) {
    return <Navigate to="/dashboards/overview" replace />;
  }

  return children;
}

export default EsgAccessRoute;
